import { useEffect, useRef, useState, useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { Formik, Field } from 'formik';
import { Button, Col, Container, Row, Form } from 'react-bootstrap';
import { useStore } from 'store';
import {
  fetchGiftsTables,
  setGiftTableSearchValues,
} from 'store/actions/giftTable';
import { resetExternalGiftTable } from 'store/actions/externalGiftTable';
import { fetchEventTypes } from 'store/actions/catalogs';
// eslint-disable-next-line no-unused-vars
import { Select, Input, DatePicker, CustomDatePicker, Card, CustomIcon, Modal, PaginationList } from 'components';
import GiftsLayout from 'components/gifts-table/GiftsLayout';
import { TableList } from 'components/gifts-table/TableList';
import { searchGiftTableFormatter } from 'services/giftTable/formatters';
// eslint-disable-next-line no-unused-vars
import searchIcon from 'assets/img/search-icon.svg';
import { FLAT } from 'constants/transformers';
import { transformForSelect } from 'util/transformHelpers';
import { isThereEvenAValue } from 'util/validations';
import { getGiftTableLink } from 'services/commons';
import { useWindowSize } from 'hooks';
import { schema } from './config';
import { columns } from './columns';
import styles from './styles.module.scss';
import { wapLink } from '../../../constants/Wap/index';
import SearchTableStep from './SearchTableStep';


const SearchTables = () => {
  const [showSearchGiftTable, setShowSearchGiftTable] = useState(false);
  const [state, dispatch] = useStore();
  const { giftTable, catalogs } = state;
  const { giftTableSearchValues = {}, listOfGiftsTables } = giftTable;
  const { flatEventTypes: eventTypes = [] } = catalogs;

  const { isMobile } = useWindowSize({ largeMobile: true })[1];

  const hasValidSearchValues = useMemo(
    () => isThereEvenAValue(giftTableSearchValues),
    [giftTableSearchValues]
  );

  const eventTypeOptions = useMemo(
    () =>
      transformForSelect(eventTypes, 'id', 'name').map((event) => ({
        ...event,
        labels: undefined,
      })),
    [eventTypes]
  );

  const formik = useRef({});

  const history = useHistory();

  const showTable = (table) => {
    if(table.hasOwnProperty('isWap') && table.isWap){
      window.open(`${wapLink}evento/${table.evento}`, '_blank');
      return;
    }
    history.push(getGiftTableLink(table, false));
  };

  const handleSubmit = (values) => {
    if (!isThereEvenAValue(values)) {
      listOfGiftsTables.results.list = [];
      dispatch(setGiftTableSearchValues({}));
      return;
    }

    const formattedValues = searchGiftTableFormatter(values);

    dispatch(fetchGiftsTables(formattedValues));
    dispatch(setGiftTableSearchValues(values));

    setShowSearchGiftTable(false);
    window.sessionStorage.removeItem('clickHomeSearch')
  };

  const handleClickSearchTable = () => {
    setShowSearchGiftTable(true);
  };

  const handleClose = () => {
    setShowSearchGiftTable(false);
  };

  const handleChange = (page) => {
    const searchValues = giftTable.giftTableSearchValues;

    const pageParam = isMobile ? page.mobilePage : page.page;

    const formattedValues =  searchGiftTableFormatter(searchValues, pageParam);

    dispatch(fetchGiftsTables(formattedValues));

    setShowSearchGiftTable(false);

    window.scrollTo(0, 0);
  };

  useEffect(() => {
    dispatch(fetchEventTypes(false, true, FLAT));

    if (!hasValidSearchValues) return;

    const formattedValues = searchGiftTableFormatter(giftTableSearchValues);

    dispatch(fetchGiftsTables(formattedValues));
  }, []);

  useEffect(() => () => dispatch(resetExternalGiftTable()), [])

  const [firstValues, setFirsValues] = useState()
  useEffect(()=>{
    const queryString = window.location.search
    if(queryString.length >= 1){
      const params = new URLSearchParams(queryString)
      const celebrate_name = params.get('festejado')
      const type_id = params.get('evento')
      const gifttable_id = params.get('numero_evento')
      const gifttable_date = params.get('fecha_evento')

      const initialValues2 = {
        customerSearsId: '',
        email: '',
        eventDate: gifttable_date || '',
        eventName: celebrate_name || '',
        eventNumber: gifttable_id || '',
        eventType: type_id || ''
      }

      setFirsValues(initialValues2)
      handleSubmit(initialValues2)
    }
  },[])
  
  useEffect(() =>{
    if(firstValues){
      if(firstValues?.eventName){
        setTimeout(() =>{
          document.querySelector('input[name="eventName"]').value = firstValues?.eventName
        },700)
      }
      if(firstValues?.eventNumber){
        setTimeout(() =>{
          document.querySelector('input[name="eventNumber"]').value = firstValues?.eventNumber
        },700)
      }
      if(firstValues?.eventDate){
        setTimeout(() =>{
          // document.querySelector('input[name="eventDate"]').value = String(firstValues?.eventDate)
        },700)
      }
    }
  },[firstValues])

  const searchGiftTableRender = (
    <Col xs={12} className="p-1">
      <Input
          className={styles.inputborder}
          containerClassName="p-0"
          labelClassName="pl-0 text-left"
          label="Festejado (a)"
          name="eventName"
          placeholder="Nombre del festejado"
          maxLength={50}
      />
      <Input
        className={styles.inputborder}
        containerClassName="p-0"
        labelClassName="pl-0 text-left"
        name="eventNumber"
        label="Número de evento"
        inputMode="numeric"
        maxLength={50}
      />
      {!isMobile ? (
      <DatePicker
        className={styles.inputborder}
        containerClassName="p-0"
        labelClassName="pl-0 text-left"
        label="Fecha del evento"
        name="eventDate"
      />
      ) : (<Field name="eventDate" component={CustomDatePicker} label='Fecha del evento' maxLength={50} />)}
      <Select
        label="Tipo de evento"
        selectContainerClassName="p-0"
        labelClassName="pl-0 text-left"
        id="eventType"
        name="eventType"
        options={eventTypeOptions}
        className={styles.inputborder}
        style={{
          border: 'none',
          borderBottomColor: 'currentcolor',
          borderBottomStyle: 'none',
          borderBottomWidth: 'medium',
          borderBottom: '1px solid darkgray !important',
          borderRadius: '0px !important',

        }}
      />
    </Col>
  );

  const totalRegistros = (listOfGiftsTables.results.list.length>0 && listOfGiftsTables.totalElements>0)?listOfGiftsTables.totalElements:0;
  

  /* visibe en desktop */
  const searchResultsLengthRender = (
    <p>
      Encontramos {listOfGiftsTables.totalElements} registros que
      coinciden con tu búsqueda
    </p>
  );

  // const withoutItems = hasGuestMode ? !hideSoldOutProducts.length : hasEmpty;
  // const inTheLastPage = currentList.length >= data.totalElements;

  useEffect(()=>{
    // console.log('listOfGiftsTables.results.list: ',listOfGiftsTables.results.list)
  },[listOfGiftsTables.results.list])

  return (
    <>
  
    {!isMobile ?
      (
    <GiftsLayout>
      <Container className={styles.paddingpage}>

        <Formik
            innerRef={formik}
            initialValues={{
              ...firstValues,
              ...giftTableSearchValues,
            }}
            validationSchema={schema}
            onSubmit={handleSubmit}
        >
          
        {(formikProps) => (
            <Form onSubmit={formikProps.handleSubmit} className={styles.maxbusqueda}>
              <Row className="pb-4 mt-lg-3">


                <Col xs={12} className="d-md-none">
                  <div className="d-flex justify-content-between align-items-center py-2 my-3">
                    <div className="d-md-none pl-1 pr-3">
                      {searchResultsLengthRender}
                    </div>
                    <div>
                      {/* <CustomIcon
                        icon={searchIcon}
                        alt="Buscar mesas de regalos"
                        onClick={handleClickSearchTable}
                      /> */}
                    </div>
                  </div>
                </Col>
                
                <div className={listOfGiftsTables.results.list.length === 0 ? 'contResTab' : 'contResTabYes'}>
                  <Col xs={12} md={3} lg={3} className="mb-4 mb-md-0 contentFilters">
                    <Card title="Buscar mesa">
                      <h6 className="text-center">
                        Puedes buscar la mesa de regalos con alguno de los siguientes datos.
                      </h6>
                      {searchGiftTableRender}
                      <Button className="mb-4 mt-4 mt-lg-3 primaryButton btn" block type="submit">
                        Buscar
                      </Button>
                    </Card>
                  </Col>

                  <Col xs={12} md={9} lg={9} className="contentResults">
                    <div className="d-none d-md-block">
                      {totalRegistros > 0 ? searchResultsLengthRender : null}
                    </div>

                    <TableList
                        data={listOfGiftsTables.results.list}
                        notResults={listOfGiftsTables.results.errorMessage}
                        notResultsActive
                        columns={columns(showTable)}
                        message="Lo sentimos, no encontramos ninguna mesa con los datos ingresados"
                        messageBold="Por favor intenta de nuevo con otros datos."
                    />
                    {listOfGiftsTables.results.list.length ? (
                        <PaginationList
                            list={listOfGiftsTables}
                            onChange={handleChange}
                            onMobileChange={handleChange}
                            // totalLimit={10000}
                        />
                    ) : null}
                  </Col>

                </div>

              </Row>
            </Form>
        )}
      </Formik>
      </Container>

    </GiftsLayout>
    ) : 
    ( 
    <SearchTableStep  />    
    )} 
    </>
  );
  
};

export default SearchTables;
